export const NODE_URL = process.env.REACT_APP_NODE_URL;
export const INSTALLATION_CODE = 'calltoinnovation';
export const MESSAGE_USER_CODE = '___user___';
export const USER_BASE_ROOM = `${INSTALLATION_CODE}${MESSAGE_USER_CODE}`;
export const NEW_CHAT_MESSAGE = 'new_chat_message';
export const TEST_STATUS_MESSAGE = 'test_status';
export const NEW_ROOM_MESSAGE = 'new_room';
export const GLOBAL_ROOM = 'rise';
export const MAX_ATTEMPTS_TO_RECONNECT = 20;
export const SEPARATOR_NAME_ROOM = '___';



// WEBPACK FOOTER //
// ./src/modules/socket/constants.js